<template>
  <div>
    <div class="christmas">
      <div class="christmas-content">
        <div class="page1">
          <div class="gift-box">
            <div class="gift-item left">
              <img src="./images/red-giftbox.png" alt="" />
              <button
                class=""
                @click="handleBuy(giftboxTypeConfig.common)"
              ></button>
            </div>
            <div class="gift-item right">
              <img src="./images/white-giftbox.png" alt="" />
              <button
                class=""
                @click="handleBuy(giftboxTypeConfig.advanced)"
              ></button>
            </div>
          </div>
          <div class="balance-box">
            <div class="balance">
              <span>{{
                userBalanceInfo.crystalBalance > 999999
                  ? '999999+'
                  : userBalanceInfo.crystalBalance
              }}</span>
              <span
                class="rules"
                @click="candyRulesVisible = !candyRulesVisible"
              ></span>
            </div>
            <span class="nicee">{{
              userBalanceInfo.balance > 999999
                ? '999999+'
                : userBalanceInfo.balance
            }}</span>
            <el-dialog
              :visible.sync="candyRulesVisible"
              title="糖果獲得規則說明："
              center
              :modal-append-to-body="false"
              class="christmas-dialog"
            >
              <div class="rules-item">
                1.
                確認完成陪玩訂單，用戶和陪玩師雙方都可獲得訂單實付金額相同數量的糖果；
              </div>
              <div class="rules-item">
                2.
                完成陪玩服務訂單：送出禮物方可獲得禮物訂單金額數量4倍的糖果，收到禮物方可獲得禮物訂單金額數量2倍的糖果；
              </div>
              <div class="rules-item">
                3. 糖果長期有效，更多神秘用途正在路上
              </div>
            </el-dialog>
          </div>
        </div>
        <div class="page2">
          <div class="page2-box">
            <div class="rules-box">
              <div class="header">
                <button @click="showRules = !showRules">
                  活動規則
                  <img
                    src="./images/triangle.png"
                    alt=""
                    :class="showRules ? 'down' : 'up'"
                  />
                </button>
                <a href="javascript:;" @click="showGiveGiftList">贈送記錄</a>
              </div>
              <p class="rules-content" v-show="showRules">
                <span class="title">活動獎勵</span><br />
                -
                所支持的陪玩師最終獲得冠軍，給該陪玩師送過指定聖誕禮物貢獻值前10名用戶可瓜分20000nicee幣；
                <br />
                - Top1陪玩師可獲得3000<img
                  class="gold-img balance-img"
                  src="./images/balance.png"
                />＋首屏1天曝光展示位<br />
                - Top2陪玩師可獲得2000<img
                  class="gold-img balance-img"
                  src="./images/balance.png"
                /><br />
                - Top3陪玩師可獲得1000<img
                  class="gold-img balance-img"
                  src="./images/balance.png"
                />
                <br />
                -
                Top10名陪玩師活動結束後將會獲得額外的首頁專屬活動頁面曝光展示<br />
                <span class="title"
                  >聖誕節前半段（12/19-12/25)——選top10預備女神</span
                ><br />
                *12月26號之前，可在當前頁面/私訊/語音房贈送陪玩師限時聖誕禮物，收到禮物會有相應的幸運值增加，魅力值Top10的陪玩師會成為預備聖誕女神參與聖誕節人氣大戰!（26號0點過後，前top10名陪玩師名單將不再變動）
                <span class="divider"></span>
                *聖誕禮物說明:<br />
                禮物會作為正常禮物結算獎勵給陪玩師<br />
                <!-- <span class="divider"></span> -->
                “聖誕鈴鐺”價值99
                <img
                  class="gold-img balance-img"
                  src="~@/assets/image/icons/diamond.png"
                />，可增加幸運值25點;<br />
                “暖心雪人”價值99<img
                  class="gold-img balance-img"
                  src="~@/assets/image/icons/diamond.png"
                />，可增加幸運值200點;<br />
                (僅“聖誕鈴鐺”與“暖心雪人”這兩款禮物可增加幸運值)
                <span class="divider"></span>
                *普通禮盒=300個<img
                  class="gold-img candy-img"
                  src="./images/candy.png"
                />;<br />
                *高級禮盒=50個<img
                  class="gold-img balance-img"
                  src="~@/assets/image/icons/gold-icon.png"
                />;
                <!-- 聖誕女神預備展示位將會在19號開放，敬請留意 -->
                <span class="divider"></span>
                <span class="title"
                  >聖誕節後半段（12/26-12/30)——預備女神決賽</span
                ><br />
                -
                12月26號-12月30號期間用戶可在當前頁面/私訊/語音房內贈送陪玩師指定禮物（聖誕鈴鐺+暖心雪人），協助陪玩師上聖誕女神位
                <span class="divider"></span>
                *12月26號後僅海選出來的10名陪玩師有參賽資格(其余陪玩師仍可正常接收禮物，但不計入活動幸運值計算)
                <span class="divider"></span>
                *12月30號12:00活動投票截止(聖誕禮物將會回收，平臺會折算成鑽石返還對應用戶)，工作人員會進行核對中獎名單後將會在平臺上進行公示
                <!-- <span class="divider"></span> -->
              </p>
            </div>
            <div class="luck-balance-box">
              <div class="balance">
                <span class="label">聖誕鈴鐺</span>
                <span class="value">{{
                  userBalanceInfo.smallBell > 9999
                    ? '9999+'
                    : userBalanceInfo.smallBell
                }}</span>
              </div>
              <div class="nicee">
                <span class="label">暖心雪人</span>
                <span class="value">{{
                  userBalanceInfo.snowman > 9999
                    ? '9999+'
                    : userBalanceInfo.snowman
                }}</span>
              </div>
            </div>
            <div class="rank-list" v-if="rankList">
              <swiper
                ref="mySwiper"
                :options="swiperOption1"
                @click.native="sliderClicked($event, rankList.slice(0, 5))"
              >
                <swiper-slide
                  v-for="(item, index) of rankList.slice(0, 5)"
                  :key="item.userUuid + '' + index"
                >
                  <div class="rank-item">
                    <div class="avatar-box">
                      <img :src="item.avatarUrl" alt="" class="avatar" />
                      <img
                        src="./images/empty.png"
                        alt=""
                        class="avatar"
                        v-show="!item.avatarUrl"
                      />
                      <img
                        src="./images/border.png"
                        alt=""
                        class="avatar-border"
                      />
                    </div>
                    <div class="luck-box">
                      <span class="label">幸運值</span><br />
                      <span class="value">{{ item.score }}</span>
                    </div>
                    <button type="button" class="send-gift-button">
                      送ta禮物
                    </button>
                  </div>
                </swiper-slide>
                <div
                  class="swiper-button-prev swiper-button-prev1"
                  slot="button-prev"
                >
                  <img src="./images/left.png" alt="" />
                </div>
                <div
                  class="swiper-button-next swiper-button-next1"
                  slot="button-next"
                >
                  <img src="./images/right.png" alt="" />
                </div>
              </swiper>
              <div class="divider"></div>
              <swiper
                ref="mySwiper2"
                :options="swiperOption2"
                @click.native="sliderClicked($event, rankList.slice(5, 10))"
              >
                <swiper-slide
                  v-for="(item, index) of rankList.slice(5, 10)"
                  :key="item.userUuid + '' + index"
                >
                  <div class="rank-item">
                    <div class="avatar-box">
                      <img :src="item.avatarUrl" alt="" class="avatar" />
                      <img
                        src="./images/empty.png"
                        alt=""
                        class="avatar"
                        v-show="!item.avatarUrl"
                      />
                      <img
                        src="./images/border.png"
                        alt=""
                        class="avatar-border"
                      />
                    </div>
                    <div class="luck-box">
                      <span class="label">幸運值</span><br />
                      <span class="value">{{ item.score }}</span>
                    </div>
                    <button type="button" class="send-gift-button">
                      送ta禮物
                    </button>
                  </div>
                </swiper-slide>
                <div
                  class="swiper-button-prev swiper-button-prev2"
                  slot="button-prev"
                >
                  <img src="./images/left.png" alt="" />
                </div>
                <div
                  class="swiper-button-next swiper-button-next2"
                  slot="button-next"
                >
                  <img src="./images/right.png" alt="" />
                </div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="盲盒購買"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      center
      top="30vh"
      class="christmas-dialog christmas-gitbox-buy"
    >
      <div class="christmas-gitbox-buy-content">
        <div
          class="input-box"
          v-if="costConfig.giftboxType === giftboxTypeConfig.common"
        >
          <span>我要</span>
          <el-input-number
            v-model="costConfig.commonGiftboxAmount"
            size="mini"
          ></el-input-number>
          <span>個普通禮盒</span>
        </div>
        <div class="input-box" v-else>
          <span>我要</span>
          <el-input-number
            v-model="costConfig.advancedGiftboxAmount"
            size="mini"
          ></el-input-number>
          <span>個高級禮盒</span>
        </div>
        <el-button
          class="btn-confirm"
          type="primary"
          size="small"
          @click="confirmBuy()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="giveGiftDialog"
      title="贈送禮品"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      center
      top="30vh"
      class="christmas-dialog christmas-give-gift dialog-center"
      :show-close="false"
      @confirm="giveGift"
    >
      <div class="label-box">
        <span>數量</span>
        <span>禮品</span>
      </div>
      <el-select v-model="giveGiftInfo.count" placeholder="數量" size="mini">
        <el-option
          v-for="item in giveGiftConfig.amountOption"
          :key="item.value"
          :label="item.text"
          :value="item.value"
          :disabled="item.disabled"
        >
        </el-option>
      </el-select>
      <el-select v-model="giveGiftInfo.giftId" placeholder="禮品" size="mini">
        <el-option
          v-for="item in giveGiftConfig.typeOption"
          :key="item.value"
          :label="item.text"
          :value="item.value"
          :disabled="item.disabled"
        >
        </el-option>
      </el-select>
      <div class="btn-box">
        <el-button
          class="btn-confirm"
          type="info"
          size="small"
          @click="giveGiftDialog = false"
          >取消</el-button
        >
        <el-button
          class="btn-confirm"
          type="primary"
          size="small"
          @click="giveGift()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="loading"
      title=""
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      center
      top="48vh"
      class="christmas-dialog draw-loading-dialog"
      :show-close="false"
    >
      <div class="draw-loading-box">
        <div class="draw-result" v-if="drawResult">
          <lottie
            :options="defaultOptions"
            :height="600"
            :width="600"
            @animCreated="handleAnimation"
          />
        </div>
        <div class="draw-loading" v-else>
          兌換中...
        </div>
      </div>
    </el-dialog>
    <give-gift-list ref="giveGiftList"></give-gift-list>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
// import amount from '@/components/common/amount';
// import { Overlay, Loading } from 'vant';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
// import redGiftBox from './images/red-giftbox-gif.gif';
// import whiteGiftBox from './images/white-giftbox-gif.gif';
import GiveGiftList from './give-gift-list';
import lottie from 'vue-lottie';
import RedGiftBoxJson from './images/red-giftbox.json';
import WhiteGiftBoxJson from './images/white-giftbox.json';
export default {
  name: 'Christmas',
  components: {
    Swiper,
    SwiperSlide,
    GiveGiftList,
    lottie
  },
  directives: {
    swiper: directive
  },
  data() {
    const giftboxTypeConfig = {
      common: 1,
      advanced: 2
    };
    return {
      userBalanceInfo: {
        balance: 10000, //nicee餘額
        crystalBalance: 10000, //糖果餘額
        smallBell: 0, //铃铛
        snowman: 0 //暖心雪人
      },
      activityData: {}, // 活动详情
      costConfig: {
        candyCostNumber: 300, //抽一次獎花費糖果數量
        niceeCostNumber: 50, //抽一次獎花費nicee幣
        smallBell: 0, //铃铛
        snowman: 0, //暖心雪人
        commonGiftboxAmount: 1, //普通禮盒購買數量
        advancedGiftboxAmount: 1, //高級禮盒購買數量
        giftboxType: giftboxTypeConfig.common //購買盲盒類型
      },
      // 禮盒類型
      giftboxTypeConfig: giftboxTypeConfig, // 盲盒类型
      dialogVisible: false, //購買彈窗
      loading: false,
      showRules: true, // 是否显示活动规则
      swiperOption1: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true
        },
        slidesPerView: 'auto',
        slideClass: 'custom-slide-class',
        navigation: {
          nextEl: '.swiper-button-next1',
          prevEl: '.swiper-button-prev1'
        }
      },
      swiperOption2: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true
        },
        slidesPerView: 'auto',
        slideClass: 'custom-slide-class2',
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2'
        }
      },
      candyRulesVisible: false, // 糖果活動規則
      rankList: null, // 幸運值排行榜
      drawResult: '', // 抽獎結果
      giveGiftInfo: {
        count: 1,
        giftId: 131,
        playerUserUuid: null,
        giftFrom: 'ACTIVITY'
      }, // 抽獎結果
      giveGiftDialog: false,
      // 送禮設置
      giveGiftConfig: {
        amountOption: [
          {
            text: '1',
            value: 1
          },
          {
            text: '10',
            value: 10
          },
          {
            text: '99',
            value: 99
          },
          {
            text: '188',
            value: 188
          },
          {
            text: '520',
            value: 520
          },
          {
            text: '1314',
            value: 1314
          }
        ],
        typeOption: [
          {
            text: '聖誕鈴鐺',
            value: 131
          },
          {
            text: '暖心雪人',
            value: 132
          }
        ]
      },
      htmlOriginalFontSize: null // html原始字体大小
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 用户uuid
    userUuid() {
      return this.userInfo ? this.userInfo.uuid : null;
    },
    // 是否普通抽獎
    isCommon() {
      return this.costConfig.giftboxType === this.giftboxTypeConfig.common;
    },
    // 支付價格
    price() {
      return this.isCommon
        ? this.costConfig.candyCostNumber * this.costConfig.commonGiftboxAmount
        : this.costConfig.niceeCostNumber *
            this.costConfig.advancedGiftboxAmount;
    },
    isFinished() {
      return true;
    },
    defaultOptions() {
      return {
        loop: false,
        autoplay: true,
        animationData: this.isCommon ? RedGiftBoxJson : WhiteGiftBoxJson
      };
    }
  },
  methods: {
    // 活動結束提醒
    showFinishedDialog() {
      if (this.isFinished) {
        this.$confirm({
          message:
            '當前活動已結束，更多福利敬請留意nicee平台，感謝您的支持呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: true,
          customClass: 'dialog-center'
        }).then(() => {
          // this.$router.push({ path: '/home' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'Christmaslottery1'
          }
        );
        if (data) {
          this.userBalanceInfo.balance = data.balance || 0;
          this.userBalanceInfo.crystalBalance = data.crystalBalance || 0;
          this.userBalanceInfo.smallBell =
            data.attachment && data.attachment[131] ? data.attachment[131] : 0;
          this.userBalanceInfo.snowman =
            data.attachment && data.attachment[132] ? data.attachment[132] : 0;
          this.rankList = [];
          for (let i = 0; i < 10; i++) {
            if (data.rankList && data.rankList[i]) {
              this.rankList[i] = data.rankList[i];
            } else {
              this.rankList[i] = {
                userUuid: '',
                nickname: '',
                avatarUrl: '',
                score: 0,
                userOnlineStatus: 'Online',
                offlineTime: null
              };
            }
            // this.$set(this.rankList[i], 'loadAvatar', false);
          }
        }
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },

    // 盲盒購買
    handleBuy(giftboxType) {
      if (this.isFinished) {
        this.showFinishedDialog();
        return;
      }
      this.costConfig.giftboxType = giftboxType;
      this.openBuyDialog();
    },
    // 打開購買數量彈窗
    openBuyDialog() {
      this.dialogVisible = true;
    },
    // 關閉購買數量彈窗
    closeBuyDialog() {
      this.dialogVisible = false;
    },
    // 打開購買數量彈窗
    setLoading() {
      this.loading = true;
    },
    // 關閉購買數量彈窗
    closeLoading() {
      this.loading = false;
      this.drawResult = '';
    },
    // 是否購買
    confirmBuy() {
      this.closeBuyDialog();
      if (
        this.isCommon
          ? this.userBalanceInfo.crystalBalance < this.price
          : this.userBalanceInfo.balance < this.price
      ) {
        this.$confirm({
          title: '提示',
          message: this.isCommon
            ? '抱歉，您當前所擁有的糖果餘額數量不足，無法兌換'
            : '抱歉，您當前所擁有的nicee幣數量不足，無法兌換',
          confirmButtonText: '確定',
          showCancelButton: false,
          customClass: 'dialog-center'
        });
        this.closeBuyDialog();
        return;
      } else {
        this.$confirm({
          title: '提示',
          message: this.isCommon
            ? `是否花費${this.price}個糖果開啓${this.costConfig
                .commonGiftboxAmount +
                Math.floor(
                  this.costConfig.commonGiftboxAmount / 10
                )}個普通禮盒？`
            : `是否花費${this.price}nicee幣開啓${this.costConfig
                .advancedGiftboxAmount +
                Math.floor(
                  this.costConfig.advancedGiftboxAmount / 10
                )}個高級禮盒？`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: true,
          customClass: 'dialog-center'
        })
          .then(async () => {
            this.getGiftboxResult();
          })
          .catch(err => {
            console.log('err', err);
          });
      }
    },
    // 獲取開盲盒結果
    async getGiftboxResult() {
      this.setLoading();
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: this.isCommon ? 'Christmaslottery1' : 'Christmaslottery2',
          count: this.isCommon
            ? this.costConfig.commonGiftboxAmount
            : this.costConfig.advancedGiftboxAmount
        });
        if (data) {
          if (this.isCommon) {
            this.userBalanceInfo.crystalBalance -= this.price;
          } else {
            this.userBalanceInfo.balance -= this.price;
          }
          this.drawResult = '獲得';
          for (let key in data) {
            if (key === '聖誕鈴鐺') {
              this.userBalanceInfo.smallBell += data[key];
            }
            if (key === '暖心雪人') {
              this.userBalanceInfo.snowman += data[key];
            }
            this.drawResult = this.drawResult + key + '*' + data[key] + ',';
          }
          this.drawResult = this.drawResult.substring(
            0,
            this.drawResult.lastIndexOf(',')
          );
        }
      } catch (error) {
        this.closeLoading();
      }
    },
    // 打開禮品盒子
    async openGiftbox() {
      await this.$confirm({
        title: '恭喜你！',
        message: this.drawResult,
        confirmButtonText: '確定',
        customClass: 'dialog-center',
        showCancelButton: false
      });
    },
    // 關閉gif動畫
    closeGif() {
      try {
        this.openGiftbox();
      } finally {
        this.closeLoading();
      }
    },
    // 打開贈送禮物彈窗
    async handleGiveGift(user) {
      if (this.isFinished) {
        this.showFinishedDialog();
        return;
      }
      const { userUuid } = user;
      if (userUuid) {
        if (userUuid == this.userUuid) {
          await this.$confirm({
            title: '提示',
            message: '不能給自己贈送禮物',
            confirmButtonText: '確定',
            closeOnClickModal: true,
            customClass: 'dialog-center',
            showCancelButton: false
          });
          return;
        }
        this.giveGiftInfo.playerUserUuid = userUuid;
        this.giveGiftDialog = true;
      }
    },
    //贈送禮物
    async giveGift() {
      this.giveGiftDialog = false;
      if (this.giveGiftInfo.giftId === 131) {
        if (this.giveGiftInfo.count > this.userBalanceInfo.smallBell) {
          try {
            await this.$confirm({
              title: '提示',
              message: `您還需要購買${this.giveGiftInfo.count -
                this.userBalanceInfo.smallBell}個聖誕鈴鐺，是否確認繼續？`,
              showCancelButton: true,
              confirmButtonText: '確定',
              closeOnClickModal: false,
              customClass: 'dialog-center'
            });
          } catch (error) {
            return;
          }
        }
      } else {
        if (this.giveGiftInfo.count > this.userBalanceInfo.snowman) {
          this.$confirm({
            title: '提示',
            message: '抱歉，您當前所擁有的暖心雪人數量不足，無法贈送',
            confirmButtonText: '確定',
            customClass: 'dialog-center'
          });
          return;
        }
      }
      try {
        const { data } = await this.$http.post('/gift/send', this.giveGiftInfo);
        if (data) {
          this.getDetail();
          this.giveGiftDialog = false;
          this.$confirm({
            title: '',
            message: '贈送成功',
            confirmButtonText: '確定',
            customClass: 'dialog-center',
            showCancelButton: false
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    showGiveGiftList() {
      this.$refs.giveGiftList.openDialog();
    },
    //跳轉個人詳情頁
    toPlayerInfo(user) {
      const { userUuid } = user;
      if (userUuid) {
        this.$router.push({
          path: `/player-detail/${userUuid}`
        });
      }
    },
    // 点击轮播图，跳转详情和赠送礼物
    sliderClicked(ev, rankList) {
      try {
        const { target } = ev;
        const path = this.returnEventPath(ev);
        const elList = Array.from(path);
        const patt = /custom-slide-class/g;
        const imgPatt = /avatar-box/g;
        const el = elList.find(item => {
          return patt.test(item.className);
        });
        const isToDetail = elList.some(item => {
          return imgPatt.test(item.className);
        });
        console.log('sliderClicked');
        if (el) {
          const index = parseInt(el.dataset.swiperSlideIndex);
          if (target.className == 'send-gift-button') {
            this.handleGiveGift(rankList[index]);
          }
          if (isToDetail) {
            this.toPlayerInfo(rankList[index]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 兼容ios
    returnEventPath(e) {
      return e.path || (e.composedPath && e.composedPath()) || '';
    },
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '0.625vw'; //设计稿宽1920 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    },
    // 显示抽奖结果
    handleAnimation(anim) {
      anim.onComplete = () => {
        this.closeGif();
      };
    }
  },
  created() {
    this.initHtmlFontSize();
    this.getDetail();
  },
  destroyed() {
    this.resetHtmlFontSize();
  }
};
</script>
<style lang="scss" scoped>
.christmas {
  width: 160rem;
  overflow: auto;
  .christmas-content {
    width: 100%;
    background: url('./images/bg.png') no-repeat center top;
    background-size: 100% auto;
    background-color: #ffcbea;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .page1 {
    width: 87.5rem;
  }

  .gift-box {
    display: flex;
    margin-top: 63.5rem;
    img {
      width: 8.58rem;
    }
    .gift-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      button {
        width: 24rem;
        height: 5rem;
        margin-top: 1.46rem;
      }
      &.left {
        button {
          margin-left: 16.83rem;
        }
        img {
          margin-left: 23.92rem;
        }
      }
      &.right {
        button {
          margin-left: 3.58rem;
        }
        img {
          margin-left: 12.83rem;
        }
      }
    }
  }

  .balance-box {
    margin-top: 43.6rem;
    border-radius: 2rem;
    font-size: 2.49rem;
    .balance,
    .nicee {
      display: inline-block;
      font-weight: bold;
      color: #670c2f;
      line-height: 4rem;
      height: 4rem;
      width: 13rem;
      text-align: center;
    }
    .balance {
      margin-left: 27rem;
      position: relative;
      .rules {
        position: absolute;
        width: 3.2rem;
        height: 3.2rem;
        border-radius: 50%;
        top: -2rem;
        right: -1rem;
      }
    }
    .nicee {
      margin-left: 25.5rem;
    }
    /deep/ .el-dialog {
      overflow: visible;
    }
  }

  .page2 {
    width: 97rem;
    padding: 0 3.8rem 4.42rem 4.59rem;
    // margin-left: 6px;
    margin-top: 14.3rem;
    margin-bottom: 60px;
    background: #fe89b6;
    border: 0.6rem solid #e34aa2;
    border-radius: 20px;
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-left: -0.4rem;
  }
  .page2-box {
    background-color: white;
    margin-top: -3px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .rules-box {
    .header {
      display: flex;
      align-items: flex-end;
      color: #670c2f;
      button {
        width: 19.58rem;
        height: 4.5rem;
        background: url('./images/activities-rules-btn.png') left top;
        background-size: 100% auto;
        font-size: 2.5rem;
        font-weight: bold;
        line-height: 4.5rem;
        margin-left: 32.58rem;
        position: relative;
        img {
          width: 1.42rem;
          height: 1.25rem;
          position: absolute;
          right: 2.4rem;
          top: 40%;
          &.up {
            transform: rotate(180deg);
          }
        }
      }
      a {
        display: inline-block;
        font-size: 2.5rem;
        font-weight: 500;
        color: #ff73a9;
        text-decoration: underline;
        margin-left: 18.25rem;
        // margin-top: 4px;
      }
    }
    .rules-content {
      padding: 4.58rem 6.5rem 0 5.57rem;
      font-size: 1.67rem;
      line-height: 2.8rem;
      .divider {
        line-height: 1.67rem;
        height: 1.67rem;
        display: block;
      }
      .title {
        font-size: 2.33rem;
        font-weight: 600;
        color: #fe89b6;
        line-height: 2.5rem;
      }
      .gold-img {
        width: 20px;
        vertical-align: text-bottom;
        margin-left: 4px;
        &.candy-img {
          width: 26px;
        }
        &.balance-img {
          width: 20px;
          margin-left: 8px;
          vertical-align: middle;
        }
      }
    }
  }
  .luck-balance-box {
    margin-top: 4.08rem;
    font-size: 2.92rem;
    .balance,
    .nicee {
      display: inline-block;
      font-size: 2.92rem;
      font-weight: bold;
      color: #670c2f;
      width: 28.5rem;
      height: 5.83rem;
      line-height: 5.83rem;
      background: url('./images/gift-number.png') no-repeat center top;
      background-size: 100% 100%;
      .label {
        font-size: 2.92rem;
        font-weight: 800;
        color: #670c2f;
        padding-left: 3.75rem;
        padding-right: 1rem;
      }
      .value {
        display: inline-block;
        width: 10rem;
        text-align: center;
      }
    }
    .balance {
      margin-left: 11.83rem;
    }
    .nicee {
      margin-left: 7.42rem;
    }
  }
  .rank-list {
    font-size: 2.43rem;
    margin-top: 5.42rem;
    padding: 0 5rem 3rem;
    /deep/ .custom-slide-class {
      width: 23.92rem !important;
    }
    /deep/ .custom-slide-class2 {
      width: 23.92rem !important;
    }
    /deep/ .swiper-button-prev,
    /deep/ .swiper-button-next {
      img {
        width: 2.4rem;
        height: auto;
      }
      button {
        width: 3.17rem;
        height: 3.17rem;
      }
      &:after {
        display: none;
      }
    }
    /deep/ .swiper-button-prev {
      left: 0;
      top: calc(50% - 4rem);
    }
    /deep/ .swiper-button-next {
      right: -0.2rem;
      top: calc(50% - 4rem);
    }
    .divider {
      padding: 2rem 0;
    }
  }
  .rank-item {
    width: 17.92rem;
    margin-left: 6rem;
    text-align: center;
    font-size: 2.42rem;
    .avatar-box {
      height: 25.17rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      padding-bottom: 1.58rem;
      position: relative;
      overflow: hidden;
      border-radius: 1rem;
    }
    .avatar-box,
    .avatar-border {
      width: 100%;
    }
    .avatar-border {
      position: absolute;
      top: 0;
      left: 0;
    }
    .avatar {
      width: 100%;
      object-fit: cover;
      border-radius: 0 0 1rem 1rem;
      max-height: 22rem;
    }
    > .luck-box {
      margin-top: 9px;
      .label {
        display: inline-block;
        color: #670c2f;
        padding-bottom: 10px;
      }
      .value {
        color: #ff73a9;
      }
    }
    > .send-gift-button {
      color: #670c2f;
      height: 4.17rem;
      width: 12.17rem;
      font-size: 2.19rem;
      background: url('./images/send.png') no-repeat;
      background-size: 100% 100%;
      margin-top: 1.33rem;
    }
  }
  .gitbox-buy-content {
    display: flex;
  }
}
</style>
<style lang="scss">
.christmas-dialog {
  text-align: center;
  .el-dialog {
    border-radius: 14px;
    max-width: 400px;
  }
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 20px;
    padding-top: 0;
  }
  .christmas-gitbox-buy-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .input-box {
      display: flex;
      align-items: center;
      // justify-content: center;
      padding-bottom: 20px;
    }
    .btn-confirm {
      width: 200px;
      border-radius: 44px;
    }
  }
  &.draw-loading-dialog {
    .el-dialog {
      background-color: inherit;
      box-shadow: none;
    }
    .draw-loading {
      font-size: 20px;
      text-align: center;
      color: white;
    }
    .draw-result {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      white-space: nowrap;
      color: #eeeeee;
      font-size: 40px;
      text-align: center;
      // width: 400px;
      img {
        max-width: 100%;
      }
    }
    .loading-icon {
      text-align: center;
      margin-bottom: 20px;
    }
  }
  &.christmas-give-gift {
    .el-input__inner {
      text-align: center;
    }
    .btn-box {
      margin-top: 40px;
      display: flex;
      justify-content: center;
    }
    .btn-confirm {
      width: 100px;
      border-radius: 44px;
    }
    .label-box {
      display: flex;
      justify-content: space-around;
      padding-bottom: 20px;
    }
  }
  .rules-item {
    margin-bottom: 10px;
  }
}
// .christmas-dialog {
//   &.christmas-gitbox-buy {
//     padding-top: 60px;
//     .el-dialog__header {
//       text-align: center;
//     }
//     .el-dialog__footer {
//       display: none;
//     }
//     .christmas-gitbox-buy-content {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       padding-bottom: 40px;
//       .title {
//         font-size: 36px;
//       }
//       .input-box {
//         display: flex;
//         align-items: center;
//         padding-bottom: 50px;
//       }
//       .btn-confirm {
//         width: 200px;
//         border-radius: 44px;
//       }
//     }
//   }
//   &.christmas-draw {
//     .draw-loading,
//     .draw-result {
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%);
//       white-space: nowrap;
//       color: #eeeeee;
//       font-size: 40px;
//       text-align: center;
//       width: 600px;
//       img {
//         max-width: 100%;
//       }
//     }
//     .loading-icon {
//       text-align: center;
//       margin-bottom: 20px;
//     }
//   }
//   &.christmas-give-gift {
//     .label-box {
//       display: flex;
//       justify-content: space-around;
//       padding-bottom: 20px;
//     }
//     // .van-dropdown-menu {
//     //   height: 80px;
//     // }
//     // .van-dropdown-menu__item {
//     //   border: 1px solid #e6e6e6;
//     //   border-radius: 4px;
//     // }
//     // .van-dropdown-menu__title::after {
//     //   display: block;
//     // }
//   }
// }
// .dialog-center {
//   .el-dialog__message,
//   .el-dialog__header {
//     text-align: center;
//   }
// }
</style>
